import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['appTextColour'])
  },
  methods: {
    /**
     * Test the darkness of the selected colour - used to determine the colour of the button text.
     * @return {boolean}
     */
    isTooDark(color, rgba) {
      let r,
        g,
        b,
        rgb;

      if (!color) {
        return false;
      }

      if (rgba) {
        const rgb = this.getRGBFromRGBAString(color);
        r = rgb.r;
        g = rgb.g;
        b = rgb.b;
      } else {
        const c = color.substring(1); // strip #
        rgb = parseInt(c, 16); // convert rrggbb to decimal
        r = (rgb >> 16) & 0xff; // extract red
        g = (rgb >> 8) & 0xff; // extract green
        b = (rgb >> 0) & 0xff; // extract blue
      }

      const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

      console.log("LUMA", luma)

      return luma < 53;
    },
    getRGBFromRGBAString(color) {
      const colorsOnly = color.substring(color.indexOf('(') + 1, color.lastIndexOf(')'))
        .split(/,\s*/);
      return {
        r: colorsOnly[0],
        g: colorsOnly[1],
        b: colorsOnly[2],
      };
    },
    convertHexToRgba(hex, alpha) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      }
      return `rgb(${r}, ${g}, ${b})`;
    },
    convertRgbaToHex(rgb) {
      rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
      return (rgb && rgb.length === 4) ? `#${
        (`0${parseInt(rgb[1], 10)
          .toString(16)}`).slice(-2)
      }${(`0${parseInt(rgb[2], 10)
        .toString(16)}`).slice(-2)
      }${(`0${parseInt(rgb[3], 10)
        .toString(16)}`).slice(-2)}` : '';
    },
  }
};
